import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getAll,
    saveMenu,
    editData,
    
};
async function saveMenu(data){
    let mobileMenu = {
        MobileMenuID: 0,
        MenuCode: data.menuCode,
        MenuName: data.menuName.trim(),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        ModifiedBy: 0,
        ModifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/MobileMenu/SaveMenu', null, mobileMenu);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/MobileMenu/GetAllMenu', null);
    return response.data;
}

async function editData(data) {
    data.MenuName = data.menuName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/MobileMenu/UpdateMenu', null, data);
    return response;
}
